import React from "react";

function roundedCornerClass(rowIdx, colIdx, numCols, numRows)
{
    if (rowIdx === 0) {
        if (colIdx === 0) {
            return 'rounded-tl-lg';
        } else if (colIdx === numCols-1) {
            return 'rounded-tr-lg';
        }
    } else if (rowIdx === numRows-1) {
        if (colIdx === 0) {
            return 'rounded-bl-lg';
        } else if (colIdx === numCols-1) {
            return 'rounded-br-lg';
        }
    }
}

const Table = ({headers, rows, onClick, rowClassName, bodyClassName, className, noBorder}) => {
    if (typeof onClick !== 'function') {
        onClick = (a, b) => null;
    }
    return (
        <div>
            <div className="hidden md:block overflow-x-auto">
                <table className={`w-full ${className || ''}`}>
                    <thead>
                        <tr>
                            {headers.map(header => (
                                <th
                                    key={header}
                                    className="column-label text-left py-2 px-4"
                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className={bodyClassName || 'panel'}>
                        {rows.map((row, rowIdx) => (
                            <tr
                                key={rowIdx}
                                onClick={() => onClick(row, rowIdx)}
                                className={rowClassName}
                            >
                                {row.map((item, idx) => (
                                    <td
                                        key={idx}
                                        className={`py-2 ${rowIdx > 0 && !noBorder ? 'border-t' : ''} ${
                                            idx === 0 ? 'pl-4 pr-4' : 'px-4'
                                        } ${roundedCornerClass(rowIdx, idx, row.length, rows.length)}`}
                                    >
                                        {item}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="md:hidden space-y-3">
                {rows.map((row, rowIdx) => (
                    <div
                        key={rowIdx}
                        onClick={() => onClick(row, rowIdx)}
                        className={`panel pl-4 py-2 rounded-lg ${rowClassName}`}
                    >
                        {row.map((item, idx) => (
                            <div
                                key={idx}
                                className={`flex justify-between items-center gap-4 pr-4 ${
                                    idx > 0 ? 'mt-2 pt-2 border-t' : ''
                                }`}
                            >
                                <span className="column-label !mb-0 text-sm font-medium flex-shrink-0">
                                    {headers[idx]}
                                </span>
                                <span className="text-right flex-1">
                                    {item}
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Table;
